var _path, _rect, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNexusDashboardDatabroker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,10.75A29.28292,29.28292,0,0,1,69.25,40h1.5a30.75,30.75,0,0,0-61.5,0h1.5A29.28292,29.28292,0,0,1,40,10.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.25,
    y: 22,
    width: 1.5,
    height: 36
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20,40.75H34.18945l-2.71972,2.71973,1.06054,1.06054,4-4a.74972.74972,0,0,0,0-1.06054l-4-4-1.06054,1.06054L34.18945,39.25H20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44,40.75H58.18945l-2.71972,2.71973,1.06054,1.06054,4-4a.74972.74972,0,0,0,0-1.06054l-4-4-1.06054,1.06054L58.18945,39.25H44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44,35.25v1.5A8.75967,8.75967,0,0,0,52.75,28v-.18945l2.71973,2.71972,1.06054-1.06054-4-4a.74972.74972,0,0,0-1.06054,0l-4,4,1.06054,1.06054L51.25,27.81055V28A7.258,7.258,0,0,1,44,35.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44,44.75A7.258,7.258,0,0,1,51.25,52v.18945l-2.71973-2.71972-1.06054,1.06054,4,4a.74971.74971,0,0,0,1.06054,0l4-4-1.06054-1.06054L52.75,52.18945V52A8.75967,8.75967,0,0,0,44,43.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNexusDashboardDatabroker);
export default __webpack_public_path__ + "static/media/icon_nexus_dashboard_databroker.1b571c58a84f2181cf28cc702f74a43e.svg";
export { ForwardRef as ReactComponent };